function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../Button';
import Icon from '../../Icon';
import classNames from '../../utils/classNames';

var AbstractCheckbox = function AbstractCheckbox(props) {
  var checked = props.checked,
      children = props.children,
      dataTrackClick = props.dataTrackClick,
      trackClick = props.trackClick,
      telemetryMeta = props.telemetryMeta,
      disabled = props.disabled,
      id = props.id,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      node = props.node,
      qa = props.qa,
      styleHooks = props.styleHooks,
      type = props.type,
      value = props.value,
      variant = props.variant;
  var target = styleHooks;
  var resolvedChildren = typeof children === 'function' ? children(checked) : children;
  var isStandardTrigger = /(standard|text-list|text-list-2)/.test(variant);
  return /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: target.root,
    "data-qa": qa
  }, /*#__PURE__*/React.createElement("input", {
    checked: checked,
    className: target.control,
    "data-qa": "".concat(qa, "#input"),
    "data-track-click": trackClick || dataTrackClick,
    "data-telemetry-meta": telemetryMeta,
    disabled: disabled,
    id: id,
    name: name,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    type: type,
    value: value,
    ref: node
  }), variant !== 'content' && /*#__PURE__*/React.createElement("span", {
    className: target.trigger
  }, type === 'checkbox' && isStandardTrigger && checked && /*#__PURE__*/React.createElement(Icon, {
    className: "psw-l-center",
    type: "tick",
    size: "2"
  })), isStandardTrigger && children && /*#__PURE__*/React.createElement("span", {
    className: "psw-p-r-5"
  }), variant === 'content' ? resolvedChildren : resolvedChildren && /*#__PURE__*/React.createElement("span", {
    className: target.label
  }, resolvedChildren));
};

AbstractCheckbox.getClassName = function (cx, type) {
  return function (_ref) {
    var size = _ref.size,
        ctaType = _ref.ctaType,
        variant = _ref.variant,
        className = _ref.className,
        checked = _ref.checked,
        disabled = _ref.disabled,
        isFocused = _ref.isFocused,
        children = _ref.children;

    if (variant === 'quick-action') {
      return {
        root: cx(Button.getClassName({
          className: className,
          size: size,
          ctaType: ctaType,
          variant: variant,
          disabled: disabled,
          isFocused: isFocused
        }).root, {
          'psw-is-active': checked
        }),
        trigger: cx('psw-hide'),
        control: cx('psw-visually-hide', 'psw-pointer-events-off'),
        label: cx('psw-l-line-center')
      };
    }

    var rootClasses;

    if (variant.includes('text-list')) {
      rootClasses = classNames({
        'psw-c-bg-interactive-2': variant === 'text-list'
      }, {
        'psw-c-bg-interactive-2a': variant === 'text-list-2'
      }, 'psw-ally-indicator', 'psw-l-line-repel', 'psw-p-x-3', 'psw-p-y-5', 'psw-r-1', 'psw-fill-x');
    }

    return {
      root: cx("psw-".concat(type), "psw-".concat(variant, "-").concat(type), {
        'psw-is-active': checked
      }, {
        'psw-is-disabled': disabled
      }, {
        'psw-is-focused': isFocused
      }, 'psw-checkbox-hide-check', className, rootClasses),
      control: cx("psw-".concat(type, "-control"), 'psw-visually-hide', 'psw-pointer-events-off'),
      trigger: cx("psw-".concat(type, "-trigger"), {
        'psw-ally-indicator psw-ally-indicator-gap-1': variant === 'standard'
      }, 'psw-r-pill'),
      label: cx("psw-".concat(type, "-label"), _defineProperty({}, cx('psw-l-line-left'), variant === 'standard' && children))
    };
  };
};

AbstractCheckbox.defaultProps = {
  qa: '',
  id: null,
  checked: false,
  dataTrackClick: null,
  trackClick: null,
  telemetryMeta: null,
  disabled: false,
  variant: 'standard',
  name: '',
  node: null,
  value: '',
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  children: null,
  styleHooks: {}
};
AbstractCheckbox.propTypes = {
  qa: PropTypes.string,
  type: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),

  /**
   * Deprecated in favor of trackClick prop
   */
  dataTrackClick: PropTypes.string,
  trackClick: PropTypes.string,
  telemetryMeta: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  checked: PropTypes.bool,
  name: PropTypes.string,
  node: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  value: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  variant: PropTypes.oneOf(['standard', 'toggle', 'text-list', 'text-list-2', 'content', 'quick-action']),
  styleHooks: PropTypes.shape({
    root: PropTypes.string,
    trigger: PropTypes.string,
    label: PropTypes.string
  })
};
export default AbstractCheckbox;